/**
 * New Text Levels
 */
export var TextLevels;
(function (TextLevels) {
    TextLevels["ONE"] = "ONE";
    TextLevels["TWO"] = "TWO";
    TextLevels["THREE"] = "THREE";
    TextLevels["FOUR"] = "FOUR";
})(TextLevels || (TextLevels = {}));
/**
 * List of available Markup for Text
 */
export var TextMarkup;
(function (TextMarkup) {
    TextMarkup["P"] = "p";
    TextMarkup["SPAN"] = "span";
    TextMarkup["DIV"] = "div";
    TextMarkup["A"] = "a";
})(TextMarkup || (TextMarkup = {}));
//# sourceMappingURL=TextEnum.js.map